export default {"src":"https://fishbrain.com/_next/static/media/editorsChoice.73b8bff1.svg","height":59,"width":95,"blurWidth":0,"blurHeight":0};